/* eslint-disable import/no-named-as-default, import/no-unresolved */
import HeroSection from './HeroSection';

export default HeroSection;
